// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/;

/**
 * Ścieżka powrotu z parametru `continue`. Tylko ścieżki wewnątrz aplikacji — inaczej parametr
 * byłby otwartym przekierowaniem. Odrzuca `//host`, `/\host`, znaki sterujące (przeglądarki
 * usuwają TAB/LF/CR z URL, więc `/<TAB>/evil.com` stawałoby się `//evil.com`) i wszystko,
 * co po rozwiązaniu wskazuje inny origin.
 */
export function safeContinuePath(raw: string | null | undefined): string {
  if (
    !raw ||
    !raw.startsWith('/') ||
    raw.startsWith('//') ||
    raw.startsWith('/\\') ||
    CONTROL_CHARS.test(raw)
  ) {
    return '/';
  }
  try {
    if (new URL(raw, window.location.origin).origin !== window.location.origin) {
      return '/';
    }
  } catch {
    return '/';
  }

  return raw;
}
